import { Text } from 'platform-components/common';
import React from 'react';

import { NewYearModalTextProps } from '../types';

import './new-year-modal__description.scss';

export const NewYearModalDescription = ({ id, values }: NewYearModalTextProps) => {
    return (
        <div className="new-year-modal__description">
            <Text id={id} type={Text.TYPE.MARKDOWN} values={values} />
        </div>
    );
};
